export type ComplianceJurisdiction =
  | 'New York'
  | 'California'
  | 'Minnesota & Oklahoma'
  | 'General'
  | 'Europe'
  | 'United Kingdom'
  | 'Rest Of World'

// The UK left this set when it got its own consent template — post-Brexit it is
// no longer covered by the EEA one.
// prettier-ignore
const EEA_COUNTRY_CODES = new Set<string>([
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR',
  'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL',
  'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
  'IS', 'LI', 'NO',
])

const US_STATE_TEMPLATE_BY_LONG_NAME: Record<string, ComplianceJurisdiction> = {
  'New York': 'New York',
  California: 'California',
  Minnesota: 'Minnesota & Oklahoma',
  Oklahoma: 'Minnesota & Oklahoma',
}

interface LocationParts {
  countryShortName?: string
  stateLongName?: string
}

export const inferComplianceJurisdiction = ({
  countryShortName,
  stateLongName,
}: LocationParts): ComplianceJurisdiction => {
  const country = countryShortName?.trim().toUpperCase() ?? ''

  if (country === 'US') {
    const stateMatch =
      US_STATE_TEMPLATE_BY_LONG_NAME[stateLongName?.trim() ?? '']
    return stateMatch ?? 'General'
  }

  if (country === 'GB') {
    return 'United Kingdom'
  }

  if (EEA_COUNTRY_CODES.has(country)) {
    return 'Europe'
  }

  return 'Rest Of World'
}
